<template>
	<div v-if="currentSong" id="detail" :class="{ 'side-opened': sideOpened, 'mainbar-extended': mainbarExtended, 'night-mode': nightMode }">
		<div id="detail-scroll">
			<h1>{{ currentSong.title }} <small @click="openAuthor">{{ currentSong.author }}</small></h1>
			<SongContentKytaristka ref="content" :song="currentSong" />
			<template v-if="isCurrentSongExternal">
				<div v-if="currentSong.source === 'kytaristka'" style="opacity: 0.5; margin-left: 20px; margin-top: 20px">👍 &nbsp; {{ $t('song.songIsChecked') }}</div>
				<div v-else style="opacity: 0.5; margin-left: 20px">
					{{ $t('song.source') }}: <a :href="currentSong.link" target="_blank">{{ currentSong.link }}</a>
				</div>
			</template>
			<div class="bottom-white-space"><br><br><br><br><br></div>
		</div>
		<DetailOverlay :current-song="currentSong"
					   @layout-changed="$refs.content.layoutChanged()" />
	</div>
</template>

<script>
	import { mapState } from "vuex";
	import { SongService } from "@/services/SongService";
	import DetailOverlay from "@/components/detail/DetailOverlay";
	import SongContentKytaristka from "@/components/detail/SongContentKytaristka";
	import {ARROW_KEYS_UP_DOWN, ARROW_KEYS_UP_DOWN__SCROLL_SONG, ControlService} from "@/services/ControlService";

	export default {
		components: {
			SongContentKytaristka,
			DetailOverlay
		},
		data() {
			return {
				touch: {
					firstTouch: null,
					panning: null,
					scrollingInterval: null
				}
			}
		},
		computed: {
			...mapState([ "currentSong", "sideOpened", "mainbarExtended", "songs", "device", "nightMode" ]),
			isCurrentSongExternal() {
				// TODO: Tohle udelat lepe. Asi donahrat konkretni zdroj do samotne databaze.
				return !("songId" in this.currentSong && this.currentSong.songId in this.songs);
			}
		},
		watch: {
			currentSong: {
				deep: true,
				handler() {
					document.dispatchEvent(new Event("StopScrolling"))
				}
			},
		},
		methods: {
			openAuthor() {
				this.$store.commit("setSongsFilter", {
					playlist: null,
					author: this.currentSong.authorId,
					onlyQueue: false
				});
				this.$store.commit("setRootSideOpened", false);
				this.$store.commit("setExternalSearchOpened", false);
			},
			touchStart(e) {
				this.touch.firstTouch = e;
			},
			touchMove(e) {
				if (e.touches.length === 1) {

					if (this.touch.firstTouch.touches[0].clientX < 40) {
						var pulled = e.changedTouches[0].clientX - this.touch.firstTouch.touches[0].clientX;
						this.$store.commit("setSidePulled", pulled > 260 ? 260 : pulled);
						document.dispatchEvent(new Event("PullingSide"));
					} else {
						var deltaX = e.changedTouches[0].clientX - this.touch.firstTouch.touches[0].clientX;
						var deltaY = e.changedTouches[0].clientY - this.touch.firstTouch.touches[0].clientY;

						if (this.touch.panning === null && Math.abs(deltaY) > 30) {
							this.touch.panning = false;
						}

						if (this.touch.panning !== false && Math.abs(deltaX) > 30) {
							this.touch.panning = true;
							this.$el.style.filter = "blur(" + Math.abs(deltaX)/1000 + "em)";
							if (Math.abs(deltaX) > 100) {
								/*this.$el.style.transform = "scale(0.92, 1)";
								if (deltaX < 0) {
									this.$el.style.transformOrigin = "top left";
								} else {
									this.$el.style.transformOrigin = "top right";
								}*/
							}
						}
					}
				}
			},
			touchEnd(e) {
				this.$store.commit("setSidePulled", 0);

				if (this.touch.firstTouch.touches[0].clientX < 20) {
					var pulled = e.changedTouches[0].clientX - this.touch.firstTouch.touches[0].clientX;
					if (pulled > 120) this.$store.commit("setSideOpened", true);
					document.dispatchEvent(new Event("PullingSide"));
				} else {
					var validTouch = this.touch.firstTouch !== null && e.changedTouches.length > 0;

					var deltaX = validTouch ? (e.changedTouches[0].clientX - this.touch.firstTouch.touches[0].clientX) : 0;
					var deltaY = validTouch ? (e.changedTouches[0].clientY - this.touch.firstTouch.touches[0].clientY) : 0;

					if (Math.abs(deltaX) < 5 && Math.abs(deltaY) < 5) {
						if (this.sideOpened) {
							this.$store.commit("setSideOpened", false);
						} else {
							document.dispatchEvent(new Event("ShowDetailOverlay"));
						}
					}

					if (this.touch.panning) {
						if (deltaX > 100) {
							document.dispatchEvent(new Event("PrevSong"));
						} else if (deltaX < -100) {
							document.dispatchEvent(new Event("NextSong"));
						}
					}

					this.$el.style.filter = "none";
					this.$el.style.transform = "none";
					this.touch = {
						firstTouch: null,
						panning: null
					};
				}
			},
			mouseMove() {
				if (this.device && (this.device.platform === "web" || this.device.platform === "desktop-mac" || this.device.platform === "desktop-win")) {
					document.dispatchEvent(new Event("ShowDetailOverlay"));
				}
			},
			scrollSongTop() {
				document.getElementById("detail-scroll").scrollTop = 0;
			},
			startScrolling() {
				this.scrollSongTop();
				this.updateScrolling();
			},
			updateScrolling() {
				if (this.currentSong.duration === null || this.currentSong.duration === undefined) {
					this.currentSong.duration = 210;
					SongService.setSongDuration(this.currentSong);
				}

				//var viewportHeight = document.getElementById("detail-scroll").offsetHeight;
				var songHeight = document.getElementById("detail-scroll").getElementsByClassName("song-content")[0].offsetHeight;
				var interval = (this.currentSong.duration / (songHeight)) * 1000;

				clearInterval(this.scrollingInterval);
				this.scrollingInterval = setInterval(() => {
					document.getElementById("detail-scroll").scrollTop = document.getElementById("detail-scroll").scrollTop + 1;
				}, interval);
			},
			stopScrolling() {
				clearInterval(this.scrollingInterval);
			},
			keydownEvent(e) {
				if (ControlService.getSettings(ARROW_KEYS_UP_DOWN) !== ARROW_KEYS_UP_DOWN__SCROLL_SONG) return;
				if (!(e.code === "ArrowDown" || e.code === "ArrowUp")) return;
				e.preventDefault();

				if (e.code === "ArrowDown") {
					document.getElementById("detail-scroll").scrollTo({
						behavior: "smooth",
						top: document.getElementById("detail-scroll").scrollTop + 200
					})
				} else if (e.code === "ArrowUp") {
					document.getElementById("detail-scroll").scrollTo({
						behavior: "smooth",
						top: document.getElementById("detail-scroll").scrollTop - 200
					})
				}
			}
		},
		mounted() {
			this.$el.addEventListener("touchstart", this.touchStart);
			this.$el.addEventListener("touchmove", this.touchMove);
			this.$el.addEventListener("touchend", this.touchEnd);
			this.$el.addEventListener("mousemove", this.mouseMove);

			document.addEventListener("ScrollSongTop", this.scrollSongTop);
			document.addEventListener("StartScrolling", this.startScrolling);
			document.addEventListener("StopScrolling", this.stopScrolling);
			document.addEventListener("UpdateScrolling", this.updateScrolling);
			document.addEventListener("keydown", this.keydownEvent);
		},
		destroy() {
			this.$el.removeEventListener("touchstart", this.touchStart);
			this.$el.removeEventListener("touchmove", this.touchMove);
			this.$el.removeEventListener("touchend", this.touchEnd);
			this.$el.removeEventListener("mousemove", this.mouseMove);

			document.removeEventListener("ScrollSongTop", this.scrollSongTop);
			document.removeEventListener("StartScrolling", this.startScrolling);
			document.removeEventListener("StopScrolling", this.stopScrolling);
			document.removeEventListener("UpdateScrolling", this.updateScrolling);
			document.removeEventListener("keydown", this.keydownEvent);
		},
	}
</script>

<style lang="scss">
	#detail {
		margin: 0;
		position: fixed;
		padding: 20px 0;
		top: 50px;
		top: calc(constant(safe-area-inset-top) + 50px);
		top: calc(env(safe-area-inset-top) + 50px);
		left: 0;
		height: calc(100vh - 50px);
		background-color: #eeeeee;
		z-index: -1;

		transition: left 0.2s, transform 0.1s, background-color 0.5s, color 0.5s;

		&.night-mode {
			background-color: #323a40;
			color: rgba(255, 255, 255, 0.75);

			a {
				color: rgba(255, 255, 255, 0.75);
			}
		}

		#detail-scroll {
			min-width: 300px;
			height: 100%;
			width: calc(100vw);
			position: relative;
			overflow-y: auto;
			overflow-x: hidden;
			white-space: normal;
			-webkit-overflow-scrolling: touch;

			-webkit-transition: width 0.2s;
			-moz-transition: width 0.2s;
			-o-transition: width 0.2s;
			transition: width 0.2s;

			h1 {
				margin-left: 20px;
			}

			&::-webkit-scrollbar {
				width: 8px;
			}

			&::-webkit-scrollbar-track {
				-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
				background-color: rgba(59, 115, 135, 0.26);
			}

			&::-webkit-scrollbar-thumb {
				background-color: rgba(42, 157, 143, 0.7);
			}
		}

		@media only screen and (max-width: 560px) {
			&.mainbar-extended {
				top: 100px;
				height: calc(100vh - 100px);
			}
		}

		&.side-opened {
			left: 260px;

			#detail-scroll {
				width: calc(100vw - 260px);
			}
		}

		h1 {
			font-size: 2em;
			margin: 0;
			padding: 0;

			small {
				opacity: 0.6;
				margin-left: 20px;
				cursor: pointer;

				&:hover {
					opacity: 0.8;
					text-decoration: underline;
				}
			}
		}

		@media only screen and (max-width: 470px) {
			h1 {
				font-size: 1em;
			}
		}

		@media only screen and (max-width: 650px) {
			h1 {
				font-size: 1.4em;
			}
		}
	}
</style>
